import { makeStyles } from '@surveycake/rc';

export const useStyles = makeStyles([
  [
    'slateHtml',
    theme => `
		& .ansTag {
			color: ${theme.color.primary.default};
		}

		& p {
			margin: 0;
		}

		& img {
			max-width: 100%;
		}

		& ol,
		& ul,
		& table {
			margin-top: 16px;
			margin-bottom: 16px;

			& p {
				margin: 0;
			}
		}

		& ol,
		& ul {
			display: block;
			padding-left: 40px;

			& > li {
				display: list-item;
				margin: 0;
				line-height: 1.4;
			}
		}

		& ul > li {
			list-style-type: disc;
		}

		& ol > li {
			list-style-type: decimal;
		}

		& table {
			display: block;
			border-collapse: collapse;

			& tbody {
				display: table-row-group;
				vertical-align: middle;
				border-color: inherit;

				& tr {
					display: table-row;
					vertical-align: inherit;
					border-color: inherit;

					& td {
						display: table-cell;
						vertical-align: top;
						min-width: 50px;
						padding: 4px;
						border: 1px solid ${theme.color.text.B};
					}
				}
			}
		}
	`
  ]
]);
